import { ActionsObservable } from 'redux-observable';
import { RootAction } from '@src/app/_redux';
import { actionCreators, GET_CLIENT_CONFIG } from '@src/app/main/actions';
import { mergeMap, map, flatMap, catchError } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { ajax } from 'rxjs/observable/dom/ajax';
import { concat } from 'rxjs/observable/concat';

export function configEpic(action$: ActionsObservable<RootAction>) {
  var adminUrl = `${process.env.SERVICE_DISCOVERY_URL}/serviceDiscovery`;

  return action$.ofType(GET_CLIENT_CONFIG).pipe(
    mergeMap(() => {
      const loading = of(actionCreators.clientConfigLoading(true));
      const request = ajax.getJSON(adminUrl).pipe(
        flatMap((response: any) => {
          return ajax
            .getJSON(
              response.url + '/AdminConfig?globalCode=' + encodeURIComponent(response.globalCode),
            )
            .pipe(
              map((res: any) =>
                actionCreators.clientConfigSuccess({
                  clientConfig: response,
                  adminConfig: res,
                }),
              ),
            );
        }),
        catchError((err: any) => {
          return of(actionCreators.clientConfigFailure(err));
        }),
      );

      return concat(loading, request);
    }),
  );
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/main/epics.ts